import { Base, createApp, importOnInteraction, importWhenVisible } from '@studiometa/js-toolkit';
import { Figure } from '@studiometa/ui';
import mixpanel from 'mixpanel-browser';
import NewsletterForm from './molecules/NewsletterForm.js';
import Header from './organisms/Header.js';
import ScrollSlider from './organisms/ScrollSlider.js';
import CategoriesDropdown from './organisms/CategoriesDropdown.js';
import CategoriesDropdownForm from './organisms/CategoriesDropdownForm.js';
import InsertedHTMLElement from './organisms/InsertedHTMLElement.js';
import Video from './molecules/Video.js';
import Slider from './molecules/Slider.js';
import Accordion from './molecules/Accordion.js';
import Filter from './organisms/Filter.js';
import GlossaryNav from './molecules/GlossaryNav.js';
import StickyBottom from './molecules/StickyBottom.js';
import DownloadLink from './atoms/DownloadLink.js';
import Charts from './atoms/Charts.js';
import { isDev } from './config.js';
import NameGuide from './organisms/NameGuide/index.js';
import MapFrance from './atoms/MapFrance.js';

/**
 * Main App class.
 */
class App extends Base {
  mixpanelDistinctID = '';

  /**
   * App config.
   * @returns {object}
   */
  static config = {
    log: isDev(),
    name: 'App',
    components: {
      Header,
      Figure,
      ScrollSlider,
      Video,
      CategoriesDropdown,
      CategoriesDropdownForm,
      Slider,
      FunnelLink: (app) =>
        importOnInteraction(() => import('./atoms/FunnelLink.js'), 'FunnelLink', 'mouseenter', app),
      NewsletterForm,
      Accordion,
      Filter,
      StickyBottom,
      GlossaryNav,
      InsertedHTMLElement,
      DownloadLink,
      NameGuide,
      Charts,
      MapFrance,
      EarlyAccess: (app) =>
        importWhenVisible(() => import('./organisms/EarlyAccess/index.js'), 'EarlyAccess', app),
    },
  };

  /**
   * Log a nice message when app is ready.
   * @returns {void}
   */
  async mounted() {
    mixpanel.init('dc53b29b7c925fcf52364a2685d683be', {
      debug: false,
      track_pageview: true,
      persistence: 'localStorage',
    });
    this.mixpanelDistinctID = await mixpanel.cookie.props.$device_id;
  }

  /**
   * Update link
   * @param  {string} url   url to set
   * @returns {void}
   */
  onDownloadLinkSetUrl(url) {
    if (this.$children.StickyBottom[0]) {
      this.$children.StickyBottom[0].updateValues(url);
    }
  }
}

export default createApp(App, document.body);
